import { useEffect } from 'react';
import { DEV_ONLY } from 'common/globalConstants';
import useAutoComplete from '@material-ui/lab/useAutocomplete'
import { BackendUser, SearchCriteria } from 'common/types'
import { useQuery } from 'hooks/use-query/useQuery'
import { useState, useLayoutEffect } from 'react'
import { useSearchApi } from 'hooks/use-search-api/useSearchApi'
import { useHashtagsApi } from 'hooks/use-mentions-api/use-hashtags-api/useHashtagsApi'
import { ITagSearchItem } from 'common/types/hashtags.types'

export const useSearchBar = (backendUser: BackendUser) => {
  const [results, setResults] = useState([])
  const [hashtagResults, setHashtagResults] = useState<ITagSearchItem[]>([])
  const [open, setOpen] = useState(false)
  const { fetchAllResultsByName } = useSearchApi()
  const [nameQuery, setNameQuery] = useState<string>('')
  const query = useQuery()
  const countryQuery = query.get('countrySearch')
  const [page, setPage] = useState(1)
  const [totalSuggestions, setTotalSuggestions] = useState(0)
  const [maxPage, setMaxPage] = useState(5)
  const [isValidSuggestion, setIsValidSuggestion] = useState(false)
  const [searchResultsIndex, setSearchResultsIndex] = useState(0)

  const { fetchTagSearchResult } = useHashtagsApi()

  const { getRootProps, getInputProps, getListboxProps, getOptionProps, groupedOptions } = useAutoComplete({
    id: 'user-search',
    // @ts-ignore
    options: results,
    // @ts-ignore
    getOptionLabel: option =>
      option.hasOwnProperty('firstName') ? `${option.firstName} ${option.lastName}` : option.partnerName,
    open: open,
    onOpen: () => {
      setOpen(true)
    },
    onClose: () => {
      setOpen(false)
    },
    clearOnBlur: false
  })

  const loading = open && (results.length === 0 || hashtagResults?.length === 0)
  const hashtagSearch = DEV_ONLY && (nameQuery[0] === '#' && nameQuery?.length > 1 && !nameQuery.includes(' '))
  const pageSize = 5


  const getMoreHashtagResults = async (_page?: number, initialList?: ITagSearchItem[]) => {
    if ((_page ?? page) <= maxPage) {
      const searchQuery = nameQuery?.toLowerCase()
      
      const results = await fetchTagSearchResult(_page ?? page, pageSize, searchQuery.slice(1))
      const isValidHashTag = results?.data?.some((tag) => tag?.topic?.startsWith(searchQuery[1]))

      if (results && isValidHashTag) {
        setIsValidSuggestion(true)
        setPage(page + 1)
        const newTotalSuggestions = parseInt(results?.totalCount)
        setTotalSuggestions(newTotalSuggestions)
        setMaxPage(Math.ceil(newTotalSuggestions / pageSize))
        setHashtagResults([...(initialList ?? hashtagResults), ...results?.data])
        return
      } else {
        setHashtagResults([])
        setIsValidSuggestion(false)
      }

      setIsValidSuggestion(false)
    }
  }

  useLayoutEffect(() => {
    let active = true
    let getData: any

    if (hashtagSearch) {

      getData = async () => await getMoreHashtagResults(1, [])
    } else {

      getData = async () => {

        const results = await fetchAllResultsByName(backendUser?.id, nameQuery)
        setResults(results?.data)
      }
    }

    setSearchResultsIndex(-1)

    if (backendUser) {
      getData()
    }
    return () => {
      active = false
    }
  }, [loading, nameQuery])

  useLayoutEffect(() => {
    if (!open) {
      setResults([])
      setHashtagResults([])
      setSearchResultsIndex(-1)
    }
  }, [open])

  return {
    getRootProps,
    getListboxProps,
    getOptionProps,
    getInputProps,
    groupedOptions,
    open,
    setOpen,
    loading,
    nameQuery,
    setNameQuery,
    countryQuery,
    results,
    hashtagResults,
    setHashtagResults,
    getMoreHashtagResults,
    totalSuggestions,
    hashtagSearch,
    isValidSuggestion,
    searchResultsIndex,
    setSearchResultsIndex,
  }
}
